import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineComponent, watch } from 'vue';
import { state as globalState, createState } from '../../store/state-snackbar';


export default /*#__PURE__*/_defineComponent({
  __name: 'Snackbar',
  props: {
  globalComponent: {
    type: Boolean,
    default: false,
  },
},
  setup(__props, { expose }) {

const props = __props;

defineComponent({ name: 'CwSnackbar' });



const state = props.globalComponent ? globalState : createState();

watch(props, (v, vo) => {
  if (v.globalComponent !== vo.globalComponent) Object.assign(state, v.globalComponent ? globalState : createState());
});

expose(state);

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_snackbar, _mergeProps({ ..._ctx.$props, ...(_unref(state).props ?? {}) }, {
    modelValue: _unref(state).display,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).display) = $event)),
    color: _unref(state).color,
    class: [_unref(state).textColor]
  }), _createSlots({
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(state).text) + " ", 1)
    ]),
    _: 2
  }, [
    _renderList(Object.keys(_ctx.$slots).filter((name) => /action/g.test(name.toString()) ? !_unref(state).textAction : true ), (slotName, index) => {
      return {
        name: slotName,
        fn: _withCtx(() => [
          _renderSlot(_ctx.$slots, slotName)
        ])
      }
    }),
    (!!_unref(state).textAction)
      ? {
          name: ":actions",
          fn: _withCtx(() => [
            _createVNode(_component_v_btn, {
              color: _unref(state).textActionColor ?? undefined,
              variant: "text",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).display = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(state).textAction), 1)
              ]),
              _: 1
            }, 8, ["color"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1040, ["modelValue", "color", "class"]))
}
}

})